import {registerDataRouterApp} from '@github-ui/react-core/register-app'

import {reposFinderAppBuilder} from './config/app-builder'
import {reposFinderLayoutRoute} from './routes/repos-finder-layout-route'
import {reposFinderPageRoute} from './routes/repos-finder-page-route'
import {ReposFinderLayoutEntrypoint} from './routes/ReposFinderLayout'
import {ReposFinderPage} from './routes/ReposFinderPage'

export const reposFinderApp = reposFinderAppBuilder.createDataRouterAppFromRoutes([
  reposFinderLayoutRoute.toRoute({
    Component: ReposFinderLayoutEntrypoint,
    children: [reposFinderPageRoute.toRoute({Component: ReposFinderPage})],
  }),
])
registerDataRouterApp(reposFinderApp)
